module.exports = __webpack_public_path__ + "img/sum_title.90bce17c.png";